// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"54":"c6dcf0ac5b63484d","560":"6bb819df7b4be922"}[chunkId] + ".js";
};